import React from 'react';
import moment from 'moment';
import { message } from 'antd';

import { CLIENTE_VARIOS } from '../../../common/types/clienteType';
import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { CONTROL_CREDITO, FACTURA, BOLETA_DE_VENTA, NOTA_VENTA } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { RUC, OTROS } from '../../../common/types/tipoDocumentoType';
import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    VENTA_MODIFICAR_TOTAL_PRODUCTO,

    CONTROL_DE_CREDITO,
    CONVERSION_MEDIDA
} from "../../../common/types/parametroType";
import printFormatMock from '../../../common/mock/printFormatMock';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import { lst_pendiente_pagos } from "../../../common/types/pendientePagoType";
import usuarioService from '../../../service/seguridad/usuarioService';
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";

import { lst_frecuencia, MENSUAL } from "../../../common/types/frecuenciaType";
import { lst_tipoServicio, PRODUCTOS } from "../../../common/types/tipoCreditoType";
import { lst_tipoPrestamo } from "../../../common/types/tipoPrestamoType";

import proyectoService from '../../../service/administracion/proyectoService';
import creditoService from '../../../service/ventas/creditoService';
import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import detraccionService from '../../../service/administracion/detraccionService';
import clienteService from '../../../service/administracion/clienteService';
import comprobanteService from '../../../service/ventas/comprobanteService';
import metodoPagoservice from '../../../service/administracion/metodoPagoService';
import cuentaService from '../../../service/administracion/cuentaService';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';
import vehiculoService from '../../../service/logistica/vehiculoService';
import notaVentaService from '../../../service/ventas/notaVentaService';
import creditoClienteService from '../../../service/creditoCobranza/creditoClienteService';
import empresaService from '../../../service/administracion/empresaService';

import creditoInteresService from '../../../service/administracion/creditoInteresService';
import fenologicaService from '../../../service/administracion/fenologicaService';
import cultivoService from '../../../service/administracion/cultivoService';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

import EditarNombreProductoModal from './EditarNombreProductoModal';
import SearchProductModal from '../../../components/SearchProductModal';
import ImprimirModal from './ImprimirModal';
import ViewModal from './ViewModal';
import ResultListResumen from './ResultListResumen';
import ViewComent from './ViewComent';
import IngresoObservacionModal from './IngresoObservacionModal';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';


import { CREDITO_COBRANZA } from '../../../common/types/moduloType';
import { VER_ALL_CRDTO_ASE, GNR_COM_VENTA } from '../../../common/types/configuracionType';


export default class Index extends PaginationBase {
    _isMounted = false;
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            loadingNew: false,
            loadingSource: true,
            loadingVer: false,
            loadingDetails: false,
            permisoGenrar: false,
            permisoUTC: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            garantes: [],
            direcciones: [],
            tiposComprobante: [],
            configuraciones: [],
            productos: [],
            detracciones: [],
            pendientePago: lst_pendiente_pagos,
            proyectos: [],
            metodosPagos: [],
            cuentas: [],
            productosAnticipo: [],
            estado: [],
            estadoDetalle: [{ id: 0, nombre: "TODOS" }, { id: 1, nombre: "PENDIENTE" }, { id: 2, nombre: "GENERADO" },],
            unidadesMedida: [],
            permisosUsuario: [],
            tipoCreditos: [],
            tipoServicios: [],
            cultivos: [],
            company: {},
            filter: {
                idEstablecimiento: 0,
                idCliente: 0,
                idTipoCredito: 0,
                idVendedor: 0,
                nroContrato: '',
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                idEstado: 0,
                documento: '',
                idProyecto: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            paginationResumen: [],

            visible: false,
            visibleDetalle: false,
            visibleComent: false,
            observacionVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: []
            },
            editarNombreProductoFormValues: {
                id: '',
                nombre: ''
            },
            detalleModal: {
                comentario: '',
                item: undefined,
                idCreditoCuota: 0,
                dataSource: []
            },
            comments: [],

            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },
            emitirVisible: false,
            emitirFilePdf: undefined,
            imprimirVisible: false,
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values
            },
            correoFormValues: {
                file: undefined,
                id: 0,
                correoCliente: ''
            },
            comprobantesForm: {
                serie: '',
                observacion: '',
                correlativo: 0,
                serieComprobante: '',
                cuota: undefined,
                idTipoComprobante: 0,
                ultimaCuota: false
            },
            cdrVisible: false,
            selectedItem: {},
            viewVisible: false,
            viewFormValues: {}
        }
    };


    fetchEmptyFormValues = (objEdit) => {
        return {
            id: objEdit !== undefined ? objEdit.credito.id : 0,
            idTipoComprobante: CONTROL_CREDITO.ID,
            idCliente: objEdit !== undefined ? objEdit.credito.idCliente : 0,
            idEstablecimientoCliente: objEdit !== undefined ? objEdit.credito.idEstablecimientoCliente : 0,
            idVendedor: objEdit !== undefined ? objEdit.credito.idVendedor : 0,
            idAlmacen: objEdit !== undefined ? objEdit.credito.idAlmacen : 0,
            idMoneda: objEdit !== undefined ? objEdit.credito.idMoneda : SOLES,
            idListaPrecio: objEdit !== undefined ? objEdit.credito.idListaPrecio : 0,
            idProyecto: objEdit !== undefined ? objEdit.credito.idProyecto : 0,
            idCredito: objEdit !== undefined ? objEdit.credito.idCredito : 0,
            idTasaInteres: objEdit !== undefined ? objEdit.credito.idTasaInteres : 0,
            idPrestamo: objEdit !== undefined ? objEdit.credito.idPrestamo : 1,
            idCultivo: objEdit !== undefined ? objEdit.credito.idPrestamo : 0,
            idFenologica: objEdit !== undefined ? objEdit.credito.idFenologica : 0,

            idEstablecimiento: objEdit !== undefined ? objEdit.credito.idEstablecimiento : 0,
            idTipoProducto: objEdit !== undefined ? objEdit.credito.idTipoProducto : PRODUCTOS,
            idUsuarioRegistro: auth.user().id,
            serie: objEdit !== undefined ? objEdit.credito.serie : "",
            documento: objEdit !== undefined ? objEdit.credito.documento : "",
            fechaStr: objEdit !== undefined ? objEdit.credito.fechaStr : global.fetchCurrentDateStr(),
            fechaVencimientoStr: objEdit !== undefined ? objEdit.credito.fechaVencimientoStr : global.fetchCurrentDateStr(),
            diasVencimiento: objEdit !== undefined ? objEdit.credito.diasVencimiento : 0,
            nroContrato: objEdit !== undefined ? objEdit.credito.nroContrato : "",
            tipoCambio: objEdit !== undefined ? objEdit.credito.tipoCambio : 0,
            observacion: objEdit !== undefined ? objEdit.credito.observacion : "",
            nroDias: objEdit !== undefined ? objEdit.credito.nroDias : 0,
            fechaInicioStr: objEdit !== undefined ? objEdit.credito.fechaInicioStr : global.fetchCurrentDateStr(),
            idTipoDocumento: objEdit !== undefined ? objEdit.credito.idTipoDocumento : 0,
            placa: objEdit !== undefined ? objEdit.credito.placa : "",
            nroSerie: objEdit !== undefined ? objEdit.credito.nroSerie : "",
            nroCuotas: objEdit !== undefined ? objEdit.credito.nroCuotas : "",
            tasa: objEdit !== undefined ? objEdit.credito.tasa : 0,

            idFrecuencia: objEdit !== undefined ? objEdit.credito.idFrecuencia : MENSUAL,
            idImpuesto: 1,
            flagCuota: objEdit !== undefined ? objEdit.credito.flagCuota : false,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            listaComprobanteCuota: [],
            listaComprobanteGarante: [],
            unidadesMedida: [],
            tipoCreditos: [],
            fenologicas: [],
            cultivos: [],
            tasaIntereses: [],
            tipoPrestamos: lst_tipoPrestamo,

            /*********************/
            sumaTotalDetalle: objEdit !== undefined ? objEdit.credito.totalDetalle : 0,
            sumaImporteDescuento: objEdit !== undefined ? objEdit.credito.importeDescuento : 0,
            sumaSubTotal: objEdit !== undefined ? objEdit.credito.subTotal : 0,
            sumaIgv: objEdit !== undefined ? objEdit.credito.igv : 0,
            sumaIsc: objEdit !== undefined ? objEdit.credito.isc : 0,
            sumaTotal: objEdit !== undefined ? objEdit.credito.total : 0,
            sumaInteres: objEdit !== undefined ? objEdit.credito.totalInteres : 0,

            porcentajeDetraccion: 0,
            importeDetraccion: 0,
            totalDetraccion: 0,
            porcentajePercepcion: 0,
            importePercepcion: 0,
            totalPercepcion: 0,
            precioUnitarioDetailDisabled: false,
            totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoCliente: objEdit !== undefined ? objEdit.credito.numeroDocumentoCliente : "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            vendedores: [],
            clientes: [],
            garantes: [],
            direcciones: [],
            tiposComprobante: [],
            frecuencias: lst_frecuencia,
            tipoServicios: lst_tipoServicio,
            detalleProductos: [],
            proyectos: [],
            tipoimpuesto: [{ id: 1, nombre: "18%" }],
            idTipoPrecio: []


        }
    };

    handleClearFilters = () => {
        var filter = {
            idEstablecimiento: 0,
            idCliente: 0,
            idTipoCredito: 0,
            idVendedor: this.state.permisoUTC ? 0 : this.state.filter.idVendedor,
            nroContrato: '',
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: this.state.filter.serie,
            idEstado: 0,
            documento: '',
            idProyecto: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleBack = () => {

        var filter = {
            ...this.state.filter,
            idCliente: 0,
            nroContrato: ''
        };
        this.setState({
            filter,
            visibleDetalle: false,
        });
        this._handlePagination(filter);

    };

    handleList = async () => {
        if (!this.state.visibleDetalle) {
            this._handlePagination(this.state.filter)
        } else {

            this.setState({
                loadingDetails: true,
            });

            var _credito = this.state.detalleModal.item.id
            var _estado = this.state.filter.idEstado

            var response = undefined;
            response = await creditoService.detalleCuota({ idCredito: _credito, idEstado: _estado });
            if (response != undefined) {
                this.setState({
                    detalleModal: {
                        ...this.state.detalleModal,
                        dataSource: response == undefined ? [] : response,
                    },
                });
            }
            this.setState({
                loadingDetails: false
            });
        }
    };


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await creditoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de creditos.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await creditoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de creditos.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await creditoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }
    handleImprimir = async (item) => {
        this.setState({ loadingPrint: true });
        var file = undefined;
        var idFormato = this.state.company.formatoPrint;
        var response;
        if (idFormato === 1) {
            response = await creditoService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await creditoService.ticket({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }
        this.setState({ loadingPrint: false });

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                fileName: item.serie + '-' + item.documento,
                idComprobante: item.id
            }
        });
    };

    handleExportCuotaPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await creditoService.cuotaPdf({ id: this.state.detalleModal.item.id });
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.detalleModal.item.serieDocumento + "-Reporte de Crédito de Cuotas.pdf");
    }

    handleExportCuotaExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await creditoService.cuotaExcel({ idCredito: this.state.detalleModal.item.id, });
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.detalleModal.item.serieDocumento + "-Reporte de Crédito de Cuotas.xlsx");
    }

    handleView = async (item) => {
        this.setState({
            loadingVer: true,
        });
        var response = await creditoService.ver({ id: item.id });
        if (response !== undefined) {
            this.setState({
                viewVisible: true,
                viewFormValues: response
            });
        }
        this.setState({
            loadingVer: false,
        });
    }
    /******************** FORM MODAL *****************/

    handleEdit = async (item) => {

        const response = await creditoService.obtenerPorId(item.id);
        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }
        var formValues = this.fetchEmptyFormValues(response);
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
        formValues.vendedores = this.state.vendedores;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
        if (response.credito.idListaPrecio == 0 || response.credito.idListaPrecio == undefined) {
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        }
        formValues.detracciones = this.state.detracciones;
        formValues.clientes = this.state.clientes;
        formValues.garantes = this.state.garantes;
        formValues.cultivos = this.state.cultivos;
        formValues.tipoCreditos = this.state.tipoCreditos;

        formValues.proyectos = this.state.proyectos;
        formValues.metodosPagos = this.state.metodosPagos;
        formValues.cuentas = this.state.cuentas;
        formValues.pendientePago = this.state.pendientePago;
        formValues.unidadesMedida = this.state.unidadesMedida;
        formValues.otroImpuesto = response.credito.otroImpuesto ? 1 : 2;
        formValues.activeKey = "3";

        const fenologicas = formValues.idCultivo == 0 ? [] : await fenologicaService.obtenerPorCultivoId(formValues.idCultivo);
        const tasaIntereses = formValues.idCredito == 0 ? [] : await creditoInteresService.obtenerPorCreditoId(formValues.idCredito);

        const productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        formValues.fenologicas = fenologicas;
        formValues.tasaIntereses = tasaIntereses;

        const direcciones = await establecimientoService.listarPorIdEntidad(response.credito.idEntidadCliente);
        var almacenes = await almacenService.listarPorIdEstablecimiento(response.credito.idEstablecimiento);

        if (almacenes != undefined && this.state.permisosUsuario.length > 0) {
            var newArray = new Array();
            var valido = false;
            var esta = formValues.establecimientos.filter(data => data.id == formValues.idEstablecimiento);

            this.state.permisosUsuario.forEach(e => {
                var regg = almacenes.filter(data => data.id == e.idAlmacen);
                if (regg.length > 0) {
                    var item = {
                        direccion: regg[0].direccion,
                        id: regg[0].id,
                        idTipoAlmacen: regg[0].idTipoAlmacen,
                        nombre: regg[0].nombre
                    }
                    newArray.push(item);
                    if (formValues.idAlmacen == regg[0].id) {
                        valido = true
                    }
                }
            });
            almacenes = newArray;
            formValues.idAlmacen = valido ? response.credito.idAlmacen : null;
            formValues.idEstablecimiento = esta.length == 0 ? null : formValues.idEstablecimiento;
            formValues.idListaPrecio = esta.length == 0 ? null : formValues.idListaPrecio;

        }
        // conversion de medida por lista de precio
        formValues.idTipoPrecio = this.state.listasPrecio.filter((m) => m.id == formValues.idListaPrecio);

        response.creditoDetalles.forEach(row => {
            const identifier = global.fetchUniqueCode();
            formValues.listaComprobanteDetalle.push(
                {
                    identifier: identifier,
                    idProducto: row.idProducto,
                    idTipoProducto: row.idTipoProducto,
                    codigo: row.codigoReferencia,
                    nombre: row.nombre,
                    numeroLote: row.numeroLote,
                    precioPromedio: row.precioPromedio,
                    porcentajeMargenComercial: row.porcentajeMargenComercial,
                    nombreUnidadMedida: row.nombreUnidadMedida,
                    idUnidadMedida: row.idUnidadMedida,
                    flagAfecto: row.flagAfecto,
                    flagGratuito: row.flagGratuito,
                    flagISC: row.flagISC,
                    isc: row.importeISC,
                    precioUnitario: row.precioUnitario,
                    cantidad: row.cantidad,
                    totalDetalle: row.totalDetalle,
                    porcentajeDescuento: row.porcentajeDescuento,
                    importeDescuento: row.importeDescuento,
                    subTotal: row.subTotal,
                    igv: row.igv,
                    total: row.total,
                    isItemLibre: row.isItemLibre,
                    flagConversion: row.flagConversion
                }
            );

            const element = row;
            formValues.detalleProductos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                idTipoProducto: element.idTipoProducto,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                idUnidadMedida: element.idUnidadMedida,
                cantidad: element.cantidad,
                precioUnitarioSinIGV: element.precioUnitarioSinIGV,
                precioUnitario: element.precioUnitario,
                precioPromedio: element.precioPromedio,
                porcentajeMargenComercial: element.porcentajeMargenComercial,
                porcentajeDescuento: element.porcentajeDescuento,
                importeDescuento: element.importeDescuento,
                total: element.total,
                flagAfecto: element.flagAfecto,
                flagISC: element.flagISC,
                flagOtrosImpuesto: element.flagOtrosImpuesto,
                flagGratuito: element.flagGratuito,
                flagChangeTotal: element.flagChangeTotal,
                subTotal: element.subTotal,
                isItemLibre: element.isItemLibre,
                flagConversion: row.flagConversion
            });
        });

        response.creditoReferencias.forEach(element => {
            formValues.listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento,
                idReferencia: element.idReferencia,
                idReferenciaOrigen: element.idReferenciaOrigen,
                flagInterno: element.flagInterno
            });
        });

        response.creditoGarantes.forEach(element => {
            formValues.listaComprobanteGarante.push({
                identifier: global.fetchUniqueCode(),
                idGarante: element.idGarante,
                nroDocumento: element.nroDocumento,
                flagInterno: element.flagInterno
            });
        });


        response.creditoCuotas.forEach(element => {
            formValues.listaComprobanteCuota.push({
                identifier: global.fetchUniqueCode(),
                correlativo: element.correlativo,
                fechaVencimiento: element.fechaVencimientoStr,
                montoCuota: element.montoCuota,
                estado: element.estado
            });
        });



        this.setState({
            // loadingNew: false,
            visible: true,
            formValues,
            productos: productos ? productos : []
        });
        this.setState({
            formValues: {
                ...this.state.formValues,
                direcciones: direcciones ? direcciones : [],
                almacenes: almacenes ? almacenes : [],
            }
        });

    }


    handleNew = async () => {

        var params = auth.user().parametros;
        var conversionMedida = params.filter((m) => m.abreviatura === CONTROL_DE_CREDITO)[0].valor === "1" ? true : false;
        if (conversionMedida) {
            this.setState({ loadingNew: true });
            var formValues = this.fetchEmptyFormValues();
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.establecimientos = this.state.permisosUsuario.length > 0 ? this.handleEstablecimiento() : this.state.establecimientos;
            formValues.vendedores = this.state.vendedores;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.detracciones = this.state.detracciones;
            formValues.clientes = this.state.clientes;
            formValues.proyectos = this.state.proyectos;
            formValues.unidadesMedida = this.state.unidadesMedida;
            formValues.garantes = this.state.garantes;
            formValues.tipoCreditos = this.state.tipoCreditos;
            formValues.cultivos = this.state.cultivos;

            const datosInicialesFilter = {
                idUsuario: auth.user().id,
                idTipoComprobante: CONTROL_CREDITO.ID
            }
            const datosIniciales = await creditoService.datosIniciales(datosInicialesFilter);

            if (datosIniciales !== undefined) {
                //formValues.idVendedor = datosIniciales.idVendedor;
                formValues.idAlmacen = datosIniciales.idAlmacen;
                formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
                formValues.idListaPrecio = datosIniciales.idListaPrecio;
                formValues.serie = datosIniciales.serie;
            }

            if (formValues.idEstablecimiento > 0) {
                const almacenes = await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
                var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);

                const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
                formValues.almacenes = almacenFilter ? almacenFilter : [];
                formValues.listasPrecio = listasPrecio ? listasPrecio : [];
            }


            if (formValues.serie == "" && formValues.serie == null) {
                setTimeout(() => {
                    dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

                }, 100);

            } else {

                this.setState({
                    loadingNew: false,
                    visible: true,
                    formValues
                });
            }

        } else {

            dialog.info('Opción no disponible en su plan actual! ');

        }


    };

    handleEstablecimiento = () => {
        var newEstablecimiento = new Array();

        if (this.state.permisosUsuario.length == 0) {
            return newEstablecimiento;
        } else {
            //return establecimiento group by
            const Oreturn = this.handleGroupBy(this.state.permisosUsuario);

            Oreturn.forEach(element => {
                var obj = this.state.establecimientos.filter(m => m.id == element);
                if (obj.length > 0) {
                    var item = {
                        codigoSunat: obj[0].codigoSunat,
                        direccion: obj[0].direccion,
                        id: obj[0].id,
                        idDepartamento: obj[0].idDepartamento,
                        idProvincia: obj[0].idProvincia,
                        idTipoEstablecimiento: obj[0].idTipoEstablecimiento,
                        idUbigeo: obj[0].idUbigeo,
                        nombre: obj[0].nombre,
                        nombreTipoEstablecimiento: obj[0].nombreTipoEstablecimiento
                    }
                    newEstablecimiento.push(item);

                }
            });

        }
        return newEstablecimiento;
    }

    handleGroupBy(array) {
        var lista = new Array();
        array.forEach(element => {
            lista.push(element.idEstablecimiento);
        });

        return lista.filter((item, index) => lista.indexOf(item) === index);
    }

    handleCredito = async (item, form) => {

        var response1 = await creditoClienteService.obtenerPorClienteId(item.idCliente, item.id);
        if (response1.status === 200) {

            const valorCreditoDisponible = Number(response1.data.valorCredito); // valor actual
            const montoSolicitado = Number(item.total); // nuevo crédito solicitado

            if (montoSolicitado > valorCreditoDisponible) {
                dialog.warning(`El cliente solo tiene ${valorCreditoDisponible} disponibles en crédito.`);
                return;
            }
            this.handleSave(item, form);

        } else {

            dialog.warning("No se puede obtener monto crédito del cliente\nO asigna el crédito al cliente");

        }
    }

    handleSave = async (item, form) => {

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            console.log(item);

            item.idCotizacion = this.state.idCotizacionImportado;

            if (item.id === 0)
                response = await creditoService.registrar(item);
            else
                response = await creditoService.modificar(item);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((item.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });

    };

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    };

    handleChangeForm = async (property, value, form) => {

        if (property === "fechaStr") {
            const fecha = moment(value, 'DD/MM/YYYY');
            const fechaVencimiento = moment(form.getFieldValue('fechaVencimientoStr'), 'DD/MM/YYYY');
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            form.setFieldsValue({
                tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                diasVencimiento: fechaVencimiento.diff(fecha, 'days').toString()
            });
        }

        if (property === "fechaInicioStr") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fechaInicioStr: value,
                }
            })
        }

        if (property === "idFrecuencia") {

            var data = form.getFieldValue(property);

            if (this.state.formValues.listaComprobanteCuota.length > 0) {
                dialog.confirm(<span>Al cambiar la frecuencia se removera las cuotas agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteCuota: [],
                            },
                        });

                    }, () => form.setFieldsValue({ [property]: data }));
            }

        }

        if (property === "idVendedor") {
            const clientes = await clienteService.obtenerPorIdVendedor(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clientes: clientes ? clientes : [],
                }
            },
                () => {
                    form.setFieldsValue({
                        idCliente: {
                            key: undefined,
                        },
                    });
                }
            );
        }


        if (property === "idCultivo") {
            const fenologicas = await fenologicaService.obtenerPorCultivoId(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    fenologicas: fenologicas ? fenologicas : [],
                }
            },
                () => {
                    form.setFieldsValue({
                        idFenologica: {
                            key: undefined,
                        },
                    });
                }
            );
        }

        if (property === "idPrestamo") {

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idCultivo: 0,
                    idFenologica: 0,
                    idPrestamo: value,
                    placa: null,
                    nroSerie: null
                }
            },
                () => {
                    form.setFieldsValue({
                        idCultivo: {
                            key: undefined,
                        },
                        idFenologica: {
                            key: undefined,
                        },
                        tasa: 0,
                        placa: null,
                        nroSerie: null
                    });
                }
            );
        }

        if (property === "idCredito") {
            if (value == 0) {
                const tasaIntereses1 = [{ id: 0, tasa: 0, nombre: 'Sin Tasa' }];
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idFrecuencia: 3, //mensual
                        tasaIntereses: tasaIntereses1,

                    }
                },
                    () => {
                        form.setFieldsValue({
                            idTasaInteres: {
                                key: undefined,
                            },
                            idFrecuencia: {
                                key: 3,
                            },
                            tasa: 0
                        });
                    }
                );
            } else {
                const tasaIntereses = await creditoInteresService.obtenerPorCreditoId(value);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idFrecuencia: 3,
                        tasaIntereses: tasaIntereses ? tasaIntereses : [],
                    }
                },
                    () => {
                        form.setFieldsValue({
                            idTasaInteres: {
                                key: undefined,
                            },
                            idFrecuencia: {
                                key: 3,
                            },
                            tasa: 0
                        });
                    }
                );
            }

        }


        if (property === "idCliente") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value.split("-")[0]);
            var vehiculos = await vehiculoService.obtenerPorClienteId(value.split("-")[1]);
            vehiculos = vehiculos.filter(e => e.flag)

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direcciones ? direcciones : [],
                    vehiculos: vehiculos ? vehiculos : []

                }
            }, () => {
                form.setFieldsValue({
                    idEstablecimientoCliente: { key: direcciones.length > 0 ? direcciones[0].id : undefined },
                    //idVehiculo: { key: vehiculos.length > 0 ? vehiculos[0].id : undefined },

                });
            });
        }

        if (property === "idPendiente") {
            //1 contado
            var listaComprobanteCuota = this.state.formValues.listaComprobanteCuota;
            if (listaComprobanteCuota.length > 0 && value == 1) { // PENDIENTE

                dialog.confirm("Al cambiar el estado se eliminaran el Método de Pago \n ¿Esta seguro de realizar la acción?", () => {

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaComprobanteCuota: [],
                            idPendiente: value,

                        }
                    });

                }, () => {

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            idPendiente: 2,

                        }
                    });

                }

                );


            } else {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idPendiente: (value === 1 ? 1 : 2),

                    },
                });
            }
            this.setState({ isPendienteSi: value == 1 ? false : true });
        }

        if (property == "idTipoProducto") {
            var data = form.getFieldValue(property);
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {

                dialog.confirm(
                    <span>
                        Al cambiar Tipo Crédito se removera los productos agregados previamente.
                        <br />
                        <span>¿Deseas continuar?'</span>
                    </span>,
                    async () => {

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                listaComprobanteCuota: [],
                                listaComprobanteReferencia: [],
                                nroCuotas: 0
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaTotal: 0,
                            nroCuotas: 0,
                            listaComprobanteDetalle: [],
                        });
                    },
                    () =>
                        form.setFieldsValue({
                            [property]: data,
                        })
                );
            }
        }


        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idCliente: undefined,
                    idEstablecimientoCliente: undefined,
                    documentoCliente: '',
                    direcciones: [],
                    idVehiculo: undefined,
                    encargado: '',
                }
            })
        }

        if (property === "idEstablecimiento" || property === "idListaPrecio" || property === "idAlmacen") {

            var data = form.getFieldValue(property);
            var label = property === "idEstablecimiento" ? "el establecimiento" : property === "idListaPrecio" ? "la lista de precio" : "el almacén";
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar {label} se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {

                        if (property === "idEstablecimiento") {
                            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                            var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
                            if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                                var newArray = new Array();
                                this.state.permisosUsuario.forEach(e => {
                                    var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                                    if (regg.length > 0) {
                                        var item = {
                                            direccion: regg[0].direccion,
                                            id: regg[0].id,
                                            idTipoAlmacen: regg[0].idTipoAlmacen,
                                            nombre: regg[0].nombre
                                        }
                                        newArray.push(item);
                                    }

                                });
                                almacenFilter = newArray;
                            }
                            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === value);
                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenFilter ? almacenFilter : [],
                                    listasPrecio: listasPrecio ? listasPrecio : []
                                }
                            });

                            form.setFieldsValue({
                                detalleProductos: [],
                                idAlmacen: undefined,
                                idListaPrecio: undefined
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: []
                            },
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0,
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                        });

                    }, () => form.setFieldsValue({ [property]: data, detalleProductos: [] }));
            }
            else {
                if (property === "idEstablecimiento") {
                    this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                    const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                    var almacenFilter = almacenes.filter(almacen => almacen.idTipoAlmacen == 1);
                    if (almacenFilter != undefined && this.state.permisosUsuario.length > 0) {
                        var newArray = new Array();
                        this.state.permisosUsuario.forEach(e => {
                            var regg = almacenFilter.filter(data => data.id == e.idAlmacen);
                            if (regg.length > 0) {
                                var item = {
                                    direccion: regg[0].direccion,
                                    id: regg[0].id,
                                    idTipoAlmacen: regg[0].idTipoAlmacen,
                                    nombre: regg[0].nombre
                                }
                                newArray.push(item);
                            }

                        });
                        almacenFilter = newArray;
                    }
                    const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === value);
                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenFilter ? almacenFilter : [],
                            listasPrecio: listasPrecio ? listasPrecio : []
                        }
                    });

                    form.setFieldsValue({
                        detalleProductos: [],
                        idAlmacen: undefined,
                        idListaPrecio: undefined
                    });
                }
                form.setFieldsValue({
                    detalleProductos: []
                });
            }
        }
    };

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await creditoService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await creditoService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file
            }
        });
    };

    handleDownloadPdf = async () => {
        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.imprimirFormValues.fileName + ".pdf");

    };

    handleBuscarCliente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

        //const response = await padronReducidoService.factura(value);

        var numberDocument = form.getFieldValue("documentoCliente");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }
        var response = undefined;

        switch (numberDocument.length) {
            case 8:
                response = await padronReducidoService.obtenerDniApi(value);
                break;
            case 11:
                response = await padronReducidoService.obtenerRucApi(value);
                break;
            default:
                response = await padronReducidoService.boleta(value);
                break;
        }



        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, clienteLoading: false } });

            return;
        }
        var vehiculos = await vehiculoService.obtenerPorClienteId(response.data.idCliente);


        if (response.status === 200) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: response.data.direcciones,
                    vehiculos: vehiculos ? vehiculos : [],
                    documentoCliente: numberDocument
                }
            }, () => {
                form.setFieldsValue({
                    clientes: response.data.clientes,
                    idCliente: response.data.clientes.length > 0 ? { key: response.data.clientes[0].id } : undefined,
                    idEstablecimientoCliente: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    direcciones: [],
                }
            }, () => {
                form.setFieldsValue({
                    clientes: [],
                    idCliente: undefined,
                    idEstablecimientoCliente: undefined
                });
            });
        }
    };

    handleBuscarProducto = async (value, form) => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key,
            codigoNombre: value
        }

        var response = await productoService.stock(filter);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        }, () => {
            form.setFieldsValue({
                dataSource: response.productos
            });
        });
    };

    handleOpenSearchProductModal = async () => {
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var _tipoProducto = this.state.onGetFieldValue('idTipoProducto');

        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idListaPrecio === undefined || idListaPrecio.key === 0) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen.key,
            idMoneda: idMoneda.key,
            idListaPrecio: idListaPrecio.key
        }

        var response = await productoService.stock(filter);
        var lista_stock = _tipoProducto.key == 2 ? response.productos.filter((m) => m.idTipoProducto == 2) : response.productos.filter((m) => m.idTipoProducto == 1);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: lista_stock
            }
        });
    };

    handleSelectProduct = async (row) => {
        var params = auth.user().parametros;
        var idListaPrecio = this.state.onGetFieldValue("idListaPrecio").key;

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

        var listaPrecio = 0;
        var itemsConversion = [];
        if (conversionMedida) {
            itemsConversion = await productoService.listarConversionProductoPorId(row.id);
            listaPrecio = this.state.listasPrecio.filter((m) => m.id == idListaPrecio);
        }

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            idTipoProducto: row.idTipoProducto,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagGratuito: row.flagGratuito,
            flagISC: row.flagISC,
            isc: 0,
            precioUnitario: row.precioUnitario,
            precioPromedio: row.precioPromedio,
            porcentajeMargenComercial: row.porcentajeMargenComercial,
            cantidad: 0,
            totalDetalle: 0,
            porcentajeDescuento: 0,
            importeDescuento: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            numeroLote: row.numeroLote,
            stock: row.stockDisponible,
            idUnidadMedida: 0,
            itemConversion: itemsConversion ? itemsConversion : [],
            flagConversion: false,
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                idTipoPrecio: listaPrecio,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idProducto: item.idProducto,
                idTipoProducto: row.idTipoProducto,
                nombre: item.nombre,
                cantidad: item.cantidad,
                precioUnitarioSinIGV: 0,
                precioPromedio: row.precioPromedio,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                precioUnitario: item.precioUnitario,
                porcentajeDescuento: item.porcentajeDescuento,
                importeDescuento: item.importeDescuento,
                total: item.total,
                flagAfecto: item.flagAfecto,
                flagISC: item.flagISC,
                flagOtrosImpuesto: false,
                flagGratuito: item.flagGratuito,
                flagChangeTotal: false,
                subTotal: 0,
                numeroLote: row.numeroLote,
                idUnidadMedida: 0,
                itemConversion: itemsConversion ? itemsConversion : [],
                flagConversion: false,
            };

            var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            detalleProductos.push(producto);
            this.state.onSetFieldsValue({ detalleProductos });
            this.state.onSetFieldsValue({ idTipoPrecio: listaPrecio });

        });
    };


    handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        // dialog.confirm(
        //   "El total de la venta excede el monto máximo establecido ¿Desea continuar?",
        //   async () => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idMoneda === undefined) {
            message.warning('Por favor seleccione la moneda.');
            return;
        }

        if (idListaPrecio === undefined) {
            message.warning('Por favor seleccione una lista de precio.');
            return;
        }

        /* PARAMETROS */
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV =
            params.filter(
                (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
            )[0].valor === "1"
                ? true
                : false;
        var porcentajeIGV = 18;

        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues
            .listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter(
            (m) => m.codigoBarra === value
        );

        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter(
                (m) => m.codigoBarra !== value
            );
            var item = filter_detalle[0];
            item.cantidad = item.cantidad + 1;
        } else {
            var filter = {
                idAlmacen: idAlmacen.key,
                idMoneda: idMoneda.key,
                idListaPrecio: idListaPrecio.key,
                codigoNombre: value,
            };

            var list = await productoService.stock(filter);
            var filter_list = list.productos.filter(
                (m) => m.codigoBarra === value
            );
            if (filter_list.length === 0) {
                alert("no existe el producto");
                return;
            }
            var row = filter_list[0];

            item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                idTipoProducto: row.idTipoProducto,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                porcentajeMargenComercial: row.porcentajeMargenComercial,
                precioPromedio: row.precioPromedio,
                flagAfecto: row.flagIGVAfecto,
                flagGratuito: row.flagGratuito,
                flagISC: row.flagISC,
                flagExonerado: row.flagExonerado,
                isc: 0,
                precioUnitario: row.precioUnitario,
                cantidad: 1,
                totalDetalle: 0,
                porcentajeDescuento: 0,
                importeDescuento: 0,
                subTotal: 0,
                igv: 0,
                total: 0,
                numeroLote: row.numeroLote,
                stock: row.stockDisponible,
            };
        }

        /* CALCULOS */
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
        item.precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? item.precioUnitario / divisorCalculoSubTotal
            : item.precioUnitario;
        item.totalDetalle = item.cantidad * item.precioUnitarioSinIGV;
        item.subTotal = item.cantidad * item.precioUnitarioSinIGV;
        item.igv = parseFloat(
            item.flagAfecto ? item.subTotal * (porcentajeIGV / 100) : 0
        );
        item.total = item.subTotal + item.igv;
        /* CALCULOS */

        listaComprobanteDetalle.push(item);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    idTipoProducto: item.idTipoProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    precioUnitarioSinIGV: item.precioUnitarioSinIGV,
                    porcentajeMargenComercial: item.porcentajeMargenComercial,
                    precioPromedio: item.precioPromedio,
                    precioUnitario: item.precioUnitario,
                    porcentajeDescuento: item.porcentajeDescuento,
                    importeDescuento: item.importeDescuento,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagISC: item.flagISC,
                    flagOtrosImpuesto: false,
                    flagGratuito: item.flagGratuito,
                    flagChangeTotal: false,
                    subTotal: 0,
                    numeroLote: item.numeroLote,
                };


                var detalleProductos = this.state.onGetFieldValue(
                    "detalleProductos"
                );
                detalleProductos = detalleProductos.filter(
                    (m) => m.identifier !== producto.identifier
                );
                detalleProductos.push(producto);
                this.state.onSetFieldsValue({
                    sumaTotalDetalle: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["totalDetalle"] || 0),
                        0
                    ),
                    sumaSubTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["subTotal"] || 0),
                        0
                    ),
                    sumaIgv: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["igv"] || 0),
                        0
                    ),
                    sumaTotal: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["total"] || 0),
                        0
                    ),
                    detalleProductos: detalleProductos,
                });
            }
        );
        //   }
        // );
    };

    handleRemoverProducto = (row, form) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var detalleProductos = form.getFieldValue('detalleProductos');
            form.setFieldsValue({
                detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            });
        });
    };

    handleEditarNombreProducto = (row, onSetFieldsValue, onGetFieldValue) => {
        var formValues = {
            id: row.identifier,
            nombre: onGetFieldValue(`arrNombre[${row.identifier}]`)
        };

        this.setState({
            editarNombreProductoVisible: true,
            editarNombreProductoFormValues: formValues,
            onSetFieldsValue,
            onGetFieldValue
        });
    };

    handleSaveEditarNombreProducto = (values, form) => {
        var unidadMedida = this.state.onGetFieldValue(`arridUnidadMedida[${values.id}]`);

        form.resetFields();
        this.setState({ editarNombreProductoVisible: false });
        var detalleProductos = this.state.onGetFieldValue("detalleProductos");
        detalleProductos.forEach(item => {
            if (item.identifier === values.id) {
                item.nombre = values.nombre;
                item.nombreUnidadMedida = unidadMedida.key == undefined ? unidadMedida.label : unidadMedida.key
                return;
            }
        });

        this.state.onSetFieldsValue({
            detalleProductos,
            [`arrNombre[${values.id}]`]: values.nombre,
            [`arridUnidadMedida[${values.id}]`]: { key: unidadMedida.key == undefined ? unidadMedida.label : unidadMedida.key },

        });
    };


    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: true
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (item) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleAddGarante = () => {
        var listaComprobanteGarante = this.state.formValues.listaComprobanteGarante;

        listaComprobanteGarante.push({
            identifier: global.fetchUniqueCode(),
            idGarante: 0,
            nroDocumento: "",
            flagInterno: true
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteGarante: listaComprobanteGarante
            }
        });
    };

    handleRemoverGarante = (item) => {
        var listaComprobanteGarante = this.state.formValues.listaComprobanteGarante.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteGarante: listaComprobanteGarante
            }
        });
    };

    handleChangeTab = (key, onSetFieldsValue) => {

        if (key == "2") { // Referencias
            onSetFieldsValue({
                flagReferencia: true
            })
        }

        if (key == "3") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            const newLocal = "2";
            if (this.state.formValues.activeKey === newLocal)
                this.handleAddReferencia();

            const cuotas = "3";
            if (this.state.formValues.activeKey === cuotas)
                this.handleAddCuota();

            const newGarante = "4";
            if (this.state.formValues.activeKey === newGarante)
                this.handleAddGarante();
        });
    };


    handleAddCuota = () => {

        // const nro_cuotas = form.getFieldValue('nroCuotas');
        var nro_cuotas = this.state.onGetFieldValue('nroCuotas');

        if (nro_cuotas == undefined || nro_cuotas == 0) {
            message.warning('Por favor ingrese nro cuotas.');
            return;
        }

        var intDay = 1;
        var listaComprobanteCuota = this.state.formValues.listaComprobanteCuota;

        if (listaComprobanteCuota.length == 0) {
            listaComprobanteCuota.push({
                identifier: global.fetchUniqueCode(),
                correlativo: listaComprobanteCuota.length + 1,
                fechaVencimiento: global.fetchCurrentDayStr1(intDay),
                montoCuota: 0,
                estado: "PENDIENTE"
            });

        } else {

            listaComprobanteCuota.push({
                identifier: global.fetchUniqueCode(),
                correlativo: listaComprobanteCuota.length + 1,
                fechaVencimiento: global.fetchCurrentMonthStr1(intDay, listaComprobanteCuota.length),
                montoCuota: 0,
                estado: "PENDIENTE"
            });

        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteCuota: listaComprobanteCuota
            }
        });
    };


    handleRemoverCuota = (item) => {

        var listaComprobanteCuota = this.state.formValues.listaComprobanteCuota.filter(m => m.identifier !== item.identifier);
        var newListaComprobanteCuota = [];
        var contador = 1;
        listaComprobanteCuota.forEach(element => {
            var cuota = element;
            cuota.correlativo = contador;
            newListaComprobanteCuota.push(cuota);
            contador += 1;
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteCuota: newListaComprobanteCuota
            }
        });
    };

    handleGenerateCuota = (form) => {

        const flagCuota = form.getFieldValue('flagCuota');
        var idPrestamo = form.getFieldValue("idPrestamo");
        var items = this.state.formValues.listaComprobanteDetalle;

        if (idPrestamo == undefined) {
            dialog.warning("Seleccione Tipo Prestamo");
            return;
        }
        if (idPrestamo.key == 1) {
            var idFrecuencia = form.getFieldValue("idFrecuencia");
            if (idFrecuencia == undefined) {
                dialog.warning("Seleccione Frecuencia");
                return;
            }
            if (idFrecuencia.key != 3) {
                dialog.warning("El Tipo Prestamo es Agro solo aplica Cuota - Mensual");
                return;
            }
        }

        if (items.length == 0) {
            dialog.warning("Añadir Detalle o Item");
            return;
        }

        if (flagCuota) {
            this.generateCuotaFija(form);
        } else {
            this.generateCuotaNormal(form);
        }
    };

    generateCuotaFija = (form) => {
        const nro_cuotas = form.getFieldValue('nroCuotas');
        const frecuencia = form.getFieldValue('idFrecuencia');
        const nro_dias = form.getFieldValue('nroDias');
        const _total = form.getFieldValue('sumaTotal');

        var listaComprobanteCuota = [];

        var fechaInicioMoment = moment(this.state.formValues.fechaInicioStr, 'DD/MM/YYYY');

        var valorDay = 1;

        if (nro_cuotas == undefined || nro_cuotas == 0) {
            message.warning('Por favor ingrese nro cuotas.');
            return;
        }
        if ((nro_dias == "" || nro_dias == "0")) {
            message.warning('Por favor ingrese nro dias.');
            return;
        }

        if (nro_cuotas > 60) {
            message.warning('El sistema solo permite 60 cuotas');
            return;
        }


        valorDay = parseInt(nro_dias);

        var primerPago = moment(fechaInicioMoment).add(valorDay, 'day');
        const fechaActual = moment(primerPago);

        var primerUltimo = moment(primerPago).add((15), 'day');
        const fechaUltimo = moment(primerUltimo);


        if (frecuencia.key == 3) {
            for (let i = 1; i <= parseInt(nro_cuotas); i++) {
                const mesSiguiente = fechaActual.clone().add(i, 'month');

                listaComprobanteCuota.push({
                    identifier: global.fetchUniqueCode(),
                    correlativo: i,
                    fechaVencimiento: mesSiguiente.format('DD/MM/YYYY'),
                    montoCuota: (parseFloat(_total) / nro_cuotas),
                    disabled: frecuencia.key == 4 ? true : false,
                    estado: "PENDIENTE"
                });
            }

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    activeKey: "3",
                    listaComprobanteCuota: listaComprobanteCuota
                }
            });
            return;
        }

        var fechaPago = [];
        fechaPago.push(primerPago.format('YYYY-MM-DD'));
        if (parseInt(nro_cuotas) >= 2) {
            fechaPago.push(primerUltimo.format('YYYY-MM-DD'));
        }


        for (let i = 1; i <= parseInt(nro_cuotas); i++) {
            const mesSiguiente = fechaActual.clone().add(i, 'month');
            const fechaSiguiente = fechaUltimo.clone().add(i, 'month');

            if (fechaPago.length < parseInt(nro_cuotas)) {
                fechaPago.push(mesSiguiente.format('YYYY-MM-DD'))
            }

            if (fechaPago.length < parseInt(nro_cuotas)) {
                fechaPago.push(fechaSiguiente.format('YYYY-MM-DD'))
            }
        }

        for (var i = 0; i < fechaPago.length; i++) {
            listaComprobanteCuota.push({
                identifier: global.fetchUniqueCode(),
                correlativo: i + 1,
                fechaVencimiento: moment(fechaPago[i], 'YYYY-MM-DD'),
                montoCuota: (parseFloat(_total) / nro_cuotas),
                disabled: frecuencia.key == 4 ? true : false,
                estado: "PENDIENTE"
            });
        }



        form.setFieldsValue({
            fechaVencimientoStr: moment(listaComprobanteCuota[listaComprobanteCuota.length - 1].fechaVencimiento, "DD/MM/YYYY"),
            diasVencimiento: valorDay * parseInt(nro_cuotas)

        });


        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: "3",
                listaComprobanteCuota: listaComprobanteCuota
            }
        });

    };

    generateCuotaNormal = (form) => {
        const nro_cuotas = form.getFieldValue('nroCuotas');
        const frecuencia = form.getFieldValue('idFrecuencia');
        const nro_dias = form.getFieldValue('nroDias');
        const _total = form.getFieldValue('sumaTotal');


        var listaComprobanteCuota = [];

        var fechaInicioMoment = moment(this.state.formValues.fechaInicioStr, 'DD/MM/YYYY');

        var valorDay = 1;
        var mensual = 30;
        var quincenal = 15;
        var semanal = 7;


        if (nro_cuotas == undefined || nro_cuotas == 0) {
            message.warning('Por favor ingrese nro cuotas.');
            return;
        }
        if (frecuencia.key == 4 && (nro_dias == "" || nro_dias == "0")) {
            message.warning('Por favor ingrese nro dias.');
            return;
        }

        if (nro_cuotas > 60) {
            message.warning('El sistema solo permite 60 cuotas');
            return;
        }

        switch (frecuencia.key) {
            case 1:
                valorDay = semanal;
                break;
            case 2:
                valorDay = quincenal;
                break;
            case 3:
                valorDay = mensual;
                break;
            default:
                valorDay = parseInt(nro_dias);
                break;
        }

        for (let i = 1; i <= parseInt(nro_cuotas); i++) {
            const fechaSiguiente = moment(fechaInicioMoment);
            fechaSiguiente.add(valorDay * i, 'day').format('DD/MM/YYYY');
            console.log(fechaSiguiente.format('YYYY-MM-DD'));

            listaComprobanteCuota.push({
                identifier: global.fetchUniqueCode(),
                correlativo: i,
                fechaVencimiento: fechaSiguiente.format('DD/MM/YYYY'),
                montoCuota: (parseFloat(_total) / nro_cuotas),
                disabled: frecuencia.key == 4 ? true : false,
                estado: "PENDIENTE"
            });
        }

        form.setFieldsValue({
            fechaVencimientoStr: moment(listaComprobanteCuota[listaComprobanteCuota.length - 1].fechaVencimiento, "DD/MM/YYYY"),
            diasVencimiento: valorDay * parseInt(nro_cuotas)

        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: "3",
                listaComprobanteCuota: listaComprobanteCuota
            }
        });

    };



    handleAprobar = async (item) => {
        dialog.confirm(`¿Desea aprobar el crédito ${item.serie}-${item.documento}?`, async () => {
            var response = await creditoService.aprobar({ id: item.id });

            if (response.status === 200) {
                dialog.success(`CRÉDITO ${item.serie}-${item.documento} aprobado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleAnular = async (item) => {
        dialog.confirm(`¿Desea anular el crédito ${item.serie}-${item.documento}?`, async () => {
            var response = await creditoService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(`CRÉDITO ${item.serie}-${item.documento} anulado correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEmitir = async (item) => {
        dialog.confirm(`¿Desea emitir el notaVenta ${item.serie}-${item.documento}?`, async () => {
            var response = await creditoService.anular({ id: item.id });

            if (response.status === 200) {
                dialog.success(`notaVenta ${item.serie}-${item.documento} emitido correctamente.`);
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleDetalle = async (item) => {

        this.setState({
            loadingDetails: true,
        });

        var response = undefined;
        response = await creditoService.detalleCuota({ idCredito: item.id, idEstado: 0 });
        if (response != undefined) {
            this.setState({
                detalleModal: {
                    ...this.state.detalleModal,
                    item: item,
                    dataSource: response == undefined ? [] : response,
                },
                comprobantesForm: {
                    ...this.state.comprobantesForm,
                    idTipoComprobante: item.idTipoComprobante,
                },
                filter: {
                    ...this.state.filter,
                    idCliente: item.idCliente,
                    nroContrato: item.nroContrato

                },
                visibleDetalle: true,
            });
        }
        this.setState({
            loadingDetails: false
        });
    };


    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: CONTROL_CREDITO.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }

    handleComent = async (item) => {

        var response = await creditoService.detalleComentario({ id: item.id });

        var _detalle = this.state.detalleModal.item;
        _detalle.idCreditoEstado = item.idCreditoEstado;

        this.setState({
            visibleComent: true,
            viewFormValues: _detalle,
            detalleModal: {
                ...this.state.detalleModal,
                idCreditoCuota: item.id,
            },
            comments: response
        });
    }

    handleChangeComent = (value) => {
        this.setState({
            detalleModal: {
                ...this.state.detalleModal,
                comentario: value,
            },
        });
    };

    handleSaveComent = async () => {

        var comments = {
            comentario: this.state.detalleModal.comentario,
            usuario: auth.user().nombre + " " + auth.user().apellidoPaterno,
            idCreditoCuota: this.state.detalleModal.idCreditoCuota,
        }

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response = await creditoService.registrarComentario(comments);

            if (response.status === 200) {
                this.setState({
                    visibleComent: false,
                    detalleModal: {
                        ...this.state.detalleModal,
                        comentario: '',
                    },
                });
                message.success('Registrado' + ' correctamente.');

                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    handleGenerateDocumento = async (item, index) => {

        if (!this.state.permisoGenrar) {
            dialog.error('Usted no tiene permiso para generar comprobantes');

            return false;
        }

        for (let i = 0; i < index; i++) {
            var reg = this.state.detalleModal.dataSource[i];
            if (reg.idCreditoEstado == 1) {
                dialog.error('Usted tiene cuotas anteriores por cancelar');
                return false;
            }
        }

        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: this.state.comprobantesForm.idTipoComprobante
        }
        const datosIniciales = await creditoService.datosIniciales(datosInicialesFilter);

        if (datosIniciales.serie == "" || datosIniciales.serie == null) {
            dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");
            return false;

        }

        const miArray = this.state.detalleModal.dataSource;
        const ultimoElemento = miArray[miArray.length - 1];
        var _ultimoCuota = item.correlativo == ultimoElemento.correlativo ? true : false;

        if (_ultimoCuota) {
            var _itemList = miArray.length - 1;
            for (let i = 0; i < _itemList; i++) {
                var reg = this.state.detalleModal.dataSource[i];
                if (!reg.flagEmitido) {
                    dialog.error('Usted tiene comprobantes pendientes por emitir ');
                    return false;
                }
            }
        }

        dialog.confirm(`¿Desea generar el comprobante ?`, async () => {
            this.setState({
                observacionVisible: true,
                comprobantesForm: {
                    ...this.state.comprobantesForm,
                    observacion: this.state.detalleModal.item.serieDocumento + '- Cuota nro ' + item.correlativo,
                    correlativo: item.correlativo,
                    serieComprobante: datosIniciales.serie.toUpperCase(),
                    cuota: item,
                    ultimaCuota: _ultimoCuota
                },
            });
        });
    }


    handleSaveDocumento = async (observacion, form) => {
        var listaComprobanteDetalle = [];
        var listaComprobanteReferencia = [];
        var nombre = observacion;
        var _total_anticipo = 0;
        var params = auth.user().parametros;
        var flagPrecioIncluyeIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

        if (this.state.productosAnticipo.length == 0) {
            dialog.error('Usted no tiene productos registrados de tipo anticipo! . Comuníquese con el administrador');
            return false;
        }

        var itemProducto = this.state.productosAnticipo.filter(m => m.idTipoProducto == this.state.detalleModal.item.idTipoProducto);

        dialog.confirm("¿Esta seguro de generar el comprobante ?", async () => {

            var response = await creditoService.obtenerPorId(this.state.detalleModal.item.id);
            var values = response.credito;
            var detalleItem = response.creditoDetalles;

            debugger
            var item = {};
            if (this.state.comprobantesForm.ultimaCuota) {
                item = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: detalleItem[0].idProducto,
                    idTipoProducto: detalleItem[0].idTipoProducto,
                    nombre: detalleItem[0].nombre,
                    nombreUnidadMedida: detalleItem[0].nombreUnidadMedida,
                    idUnidadMedida: detalleItem[0].idUnidadMedida,
                    flagAfecto: true,
                    flagGratuito: false,
                    flagExonerado: false,
                    flagISC: false,
                    isc: 0,
                    precioUnitario: (detalleItem[0].precioUnitario),
                    cantidad: parseFloat(detalleItem[0].cantidad),
                    precioUnitarioSinIGV: detalleItem[0].precioUnitarioSinIGV,
                    totalDetalle: detalleItem[0].totalDetalle,
                    porcentajeDescuento: 0,
                    porcentajeMargenComercial: 0,
                    precioPromedio: 0,
                    importeDescuento: 0,
                    subTotal: 0,
                    igv: 0,
                    total: values.total,
                    numeroLote: detalleItem[0].numeroLote ? detalleItem[0].numeroLote : '000000000000',
                    stock: 10,
                    itemConversion: []
                };
            } else {


                item = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: itemProducto[0].id,
                    idTipoProducto: this.state.detalleModal.item.idTipoProducto,
                    nombre: nombre.observacion,
                    nombreUnidadMedida: itemProducto[0].nombreUnidadMedida,
                    idUnidadMedida: itemProducto[0].idUnidadMedida,
                    flagAfecto: true,
                    flagGratuito: false,
                    flagExonerado: false,
                    flagISC: false,
                    isc: 0,
                    precioUnitario: flagPrecioIncluyeIGV ? this.state.comprobantesForm.cuota.montoCuota : (this.state.comprobantesForm.cuota.montoCuota / 1.18),
                    cantidad: 1,
                    precioUnitarioSinIGV: this.state.comprobantesForm.cuota.montoCuota / 1.18,
                    totalDetalle: this.state.comprobantesForm.cuota.montoCuota / 1.18,
                    porcentajeDescuento: 0,
                    porcentajeMargenComercial: 0,
                    precioPromedio: 0,
                    importeDescuento: 0,
                    subTotal: 0,
                    igv: 0,
                    total: this.state.comprobantesForm.cuota.montoCuota,
                    numeroLote: detalleItem[0].numeroLote ? detalleItem[0].numeroLote : '000000000000',
                    stock: 10,
                    itemConversion: []
                };
            }

            listaComprobanteDetalle.push(item);

            if (response.creditoCuotas[0].montoInteres > 0) {

                var itemProducto1 = this.state.productosAnticipo.filter(m => m.idTipoProducto == 2);

                var montoInteresCuota = response.creditoCuotas[0].montoInteres;
                var finalInteres = parseFloat(response.creditoCuotas.reduce((a, b) => a + (b["montoInteres"] || 0), 0));
                var montoInteres = this.state.comprobantesForm.ultimaCuota ? finalInteres : montoInteresCuota;

                var item1 = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: itemProducto1[0].id,
                    idTipoProducto: itemProducto1[0].idTipoProducto,
                    nombre: 'Interes Generado',
                    nombreUnidadMedida: itemProducto1[0].nombreUnidadMedida,
                    idUnidadMedida: itemProducto1[0].idUnidadMedida,
                    flagAfecto: true,
                    flagGratuito: false,
                    flagExonerado: false,
                    flagISC: false,
                    isc: 0,
                    precioUnitario: flagPrecioIncluyeIGV ? montoInteres : (montoInteres / 1.18),
                    cantidad: 1,
                    precioUnitarioSinIGV: montoInteres / 1.18,
                    totalDetalle: montoInteres / 1.18,
                    porcentajeDescuento: 0,
                    porcentajeMargenComercial: 0,
                    precioPromedio: 0,
                    importeDescuento: 0,
                    subTotal: 0,
                    igv: 0,
                    total: montoInteres,
                    numeroLote: '000000000000',
                    stock: 10,
                    itemConversion: []
                };
                listaComprobanteDetalle.push(item1);

            }



            if (this.state.comprobantesForm.ultimaCuota) {
                this.state.detalleModal.dataSource.forEach(element => {
                    if (element.serieDocumento != null) {
                        listaComprobanteReferencia.push({
                            identifier: global.fetchUniqueCode(),
                            idReferencia: 0,
                            idReferenciaOrigen: 0,
                            idTipoComprobante: element.idTipoDocumento,
                            serie: element.serieDocumento.split("-")[0],
                            documento: element.serieDocumento.split("-")[1],
                            flagInterno: false
                        });
                        _total_anticipo = _total_anticipo + (element.totalInteres);
                    }
                });
            }

            const data = {
                id: 0,
                idMovimiento: 0,
                idTipoComprobante: values.idTipoDocumento,
                idCliente: values.idCliente,
                idEstablecimientoCliente: values.idEstablecimientoCliente,
                idVendedor: values.idVendedor,
                idAlmacen: values.idAlmacen,
                idMoneda: values.idMoneda,
                idCaja: 0,
                idFormaPago: 1,//contado
                idListaPrecio: values.idListaPrecio,
                idEstablecimiento: values.idEstablecimiento,
                idDetraccion: 0,
                totalDetraccion: 0,
                idUsuarioRegistro: auth.user().id,
                serie: this.state.comprobantesForm.serieComprobante,
                documento: null,
                fechaStr: global.fetchCurrentDateStr(),
                fechaVencimientoStr: global.fetchCurrentDateStr(),
                diasVencimiento: 0,
                numeroPlaca: null,
                idNotaVentaEstado: 1, // PENDIENTE
                tipoCambio: parseFloat(values.tipoCambio),
                observacion: nombre.observacion,
                idProyecto: values.idProyecto == null ? 0 : values.idProyecto,
                idFenologica: values.idFenologica == null ? 0 : values.idFenologica,
                condicionPago: null,
                montoRecibido: 0,
                montoVuelto: 0,
                flagDescuentoGlobal: false,
                flagExportacion: false,
                flagPercepcion: false,
                flagDetraccion: false,
                flagRetencion: false,
                porcentajeRetencion: 0,
                importeRetencion: 0,
                totalRetencion: 0,
                direccionCliente: null,
                otroImpuesto: false,
                flagAnticipo: this.state.comprobantesForm.ultimaCuota ? false : true,
                flagRegularizacion: this.state.comprobantesForm.ultimaCuota ? true : false,
                idPendiente: 1, // 2 cancelado (NC)
                total: values.total,
                encargado: null,
                montoAnticipo: parseFloat(_total_anticipo),
                importeDescuentoGlobal: 0,
                porcentajeDescuentoGlobal: 0,
                listaComprobanteDetalle: listaComprobanteDetalle,
                listaComprobanteReferencia: listaComprobanteReferencia,
                listaComprobanteCuota: []
            };


            var response = undefined;
            if (this.state.detalleModal.item.idTipoComprobante == NOTA_VENTA.ID) {
                response = await notaVentaService.registrar(data);
            }
            else {
                response = await comprobanteService.registrar(data);
            }

            if (response.status === 200) {
                this.setState({
                    visibleComent: false,
                    observacionVisible: false,
                });
                form.resetFields();
                //2-cancelado
                var dataCuota = {
                    idCreditoCuota: this.state.comprobantesForm.cuota.id,
                    idCreditoCuotaEstado: 2,
                    idComprobante: this.state.detalleModal.item.idTipoComprobante != NOTA_VENTA.ID ? response.data : 0,
                    idNotaVenta: this.state.detalleModal.item.idTipoComprobante == NOTA_VENTA.ID ? response.data : 0,
                }
                var rponse = await creditoService.modificarCreditoCuota(dataCuota)
                this.handleDetalle(this.state.detalleModal.item);
                message.success('Registrado' + ' correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }




    async componentDidMount() {
        this._isMounted = true;
        var idUsuario = auth.user().id;
        const empresa = await empresaService.obtenerPrincipal(0);

        var _usuario = auth.user();


        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: CREDITO_COBRANZA });

        const permisosUsuario = await usuarioService.usarioEstablecimiento(idUsuario, 1);

        var _vendedores = await vendedorService.listar();
        var _clientes = await clienteService.listar();
        var _garantes = _clientes.length > 0 ? _clientes.filter(e => e.tipoDocumentoNombre != "RUC") : [];

        var flagUTC = configuraciones.filter((m) => m.abreviatura === VER_ALL_CRDTO_ASE).length >= 1 ? true : false;
        var flagGCG = configuraciones.filter((m) => m.abreviatura === GNR_COM_VENTA).length >= 1 ? true : false;

        _vendedores = flagUTC ? _vendedores : _vendedores.filter(m => m.numeroDocumento == _usuario.numeroDocumento);

        if (_vendedores.length > 0) {
            _clientes = flagUTC ? _clientes.filter(m => m.idVendedor != 0) : _clientes.filter(m => m.idVendedor == _vendedores[0].id);
        }

        var idVendedor = flagUTC ? 0 : _vendedores.length > 0 ? _vendedores[0].id : 0;

        this._initPagination({ ...this.state.filter, idVendedor }, creditoService.paginacion);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        var tiposComprobante = await tipoComprobanteService.listar();
        const detracciones = await detraccionService.listar();
        const proyectos = await proyectoService.listar();
        const estado = await creditoService.listarEstado();
        tiposComprobante = tiposComprobante.filter(m => m.id == BOLETA_DE_VENTA.ID || m.id == FACTURA.ID || m.id == NOTA_VENTA.ID);
        const metodosPagos = await metodoPagoservice.listar();
        const cuentas = await cuentaService.listar();
        const unidadesMedida = await unidadMedidaService.listar();
        const productosAnticipo = await productoService.listarAnticipo();
        const tipoCreditos = await creditoInteresService.listarTipoCredito();
        const cultivos = await cultivoService.listar();


        if (this._isMounted) {
            this.setState({
                loadingSource: false,
                tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
                monedas: monedas ? monedas : [],
                listasPrecio: listasPrecio ? listasPrecio : [],
                establecimientos: establecimientos ? establecimientos : [],
                vendedores: _vendedores ? _vendedores : [],
                tiposComprobante: tiposComprobante ? tiposComprobante : [],
                detracciones: detracciones ? detracciones : [],
                clientes: _clientes ? _clientes : [],
                garantes: _garantes,
                proyectos: proyectos ? proyectos : [],
                productosAnticipo: productosAnticipo ? productosAnticipo : [],
                metodosPagos: metodosPagos ? metodosPagos : [],
                cuentas: cuentas ? cuentas : [],
                estado: estado ? estado : [],
                unidadesMedida: unidadesMedida ? unidadesMedida : [],
                permisosUsuario: permisosUsuario ? permisosUsuario : [],
                configuraciones: configuraciones ? configuraciones : [],
                tipoCreditos: tipoCreditos ? tipoCreditos : [],
                cultivos: cultivos ? cultivos : [],
                company: empresa,

                permisoGenrar: flagGCG,
                permisoUTC: flagUTC,
                filter: {
                    ...this.state.filter,
                    idVendedor: flagUTC ? 0 : _vendedores.length > 0 ? _vendedores[0].id : 0
                }

            });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    };

    render() {
        return (
            <div>
                <Header
                    title={!this.state.visibleDetalle ? "Control de Crédito" : "Detalle de cuotas - NRO " + this.state.detalleModal.item.serieDocumento}
                    onNew={this.handleNew}
                    onBack={this.handleBack}
                    visibleDetalle={this.state.visibleDetalle}
                    loadingNew={this.state.loadingSource}
                    onSearch={this.handleList}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    lista_clientes={this.state.clientes}
                    estado={this.state.estado}
                    estadoDetalle={this.state.estadoDetalle}
                    establecimientos={this.state.establecimientos}
                    tipoCredito={this.state.formValues.tipoCreditos}
                    proyectos={this.state.proyectos}
                    vendedores={this.state.vendedores}
                    visibleDetalle={this.state.visibleDetalle}
                    configuraciones={this.state.configuraciones}

                />
                {this.state.visibleDetalle ?
                    <ResultListResumen
                        pagination={this.state.detalleModal.dataSource}
                        loadingEdit={this.state.loadingSource}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        loadingPrint={this.state.loadingPrint}
                        onExportExcel={this.handleExportCuotaExcel}
                        onExportPdf={this.handleExportCuotaPdf}
                        onComentario={this.handleComent}
                        onInvoice={this.handleGenerateDocumento}
                        onChange={() => console.log('object')}
                    />
                    : <ResultList
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        loadingVer={this.state.loadingVer}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        loadingDetails={this.state.loadingDetails}
                        loadingPrint={this.state.loadingPrint}

                        onPrint={this.handlePrint}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onEdit={this.handleEdit}
                        onChange={this._handleChangePagination}
                        onView={this.handleView}
                        onEmitir={this.handleEmitir}
                        onAnular={this.handleAnular}
                        onAprobar={this.handleAprobar}
                        onImprimir={this.handleImprimir}
                        onDetails={this.handleDetalle}
                    />}


                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarCliente={this.handleBuscarCliente}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onRemoverGarante={this.handleRemoverGarante}
                    onEditarNombreProducto={this.handleEditarNombreProducto}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleCredito}
                    onScanerProduct={this.handleScanerProduct}
                    onRemoverCuota={this.handleRemoverCuota}
                    onGenerarCuotas={this.handleGenerateCuota}
                />

                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    dataSource={this.state.searchProductFormValues.dataSource}
                    dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
                    onSelect={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />


                <EditarNombreProductoModal
                    visible={this.state.editarNombreProductoVisible}
                    formValues={this.state.editarNombreProductoFormValues}
                    onClose={() => this.setState({ editarNombreProductoVisible: false })}
                    onSave={this.handleSaveEditarNombreProducto}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

                <ViewModal
                    visible={this.state.viewVisible}
                    formValues={this.state.viewFormValues}
                    onClose={() => this.setState({ viewVisible: false })}
                />

                <ViewComent
                    visible={this.state.visibleComent}
                    onChange={this.handleChangeComent}
                    formValues={this.state.viewFormValues}
                    comments={this.state.comments}
                    comentario={this.state.detalleModal.comentario}
                    onClose={() => this.setState({ visibleComent: false })}
                    onSave={this.handleSaveComent}
                />

                <IngresoObservacionModal
                    visible={this.state.observacionVisible}
                    formValues={this.state.comprobantesForm}
                    onClose={() => this.setState({ observacionVisible: false })}
                    onSave={this.handleSaveDocumento}
                />
            </div>
        )
    }
}